{
  "*": {
    "top": {
      "type": "string",
      "title": "Top",
      "controls": "slider",
      "units": ["px"],
      "min": -100,
      "max": 100,
      "step": 1,
      "default": "0px",
      "responsive": true,
      "group": "Position",
      "hidden": true
    },
    "bottom": {
      "type": "string",
      "title": "Bottom",
      "controls": "slider",
      "units": ["px"],
      "min": -100,
      "max": 100,
      "step": 1,
      "default": "0px",
      "responsive": true,
      "group": "Position",
      "hidden": true
    },
    "left": {
      "type": "string",
      "title": "Left",
      "controls": "slider",
      "units": ["px"],
      "min": -100,
      "max": 100,
      "step": 1,
      "default": "0px",
      "responsive": true,
      "group": "Position",
      "hidden": true
    },
    "right": {
      "type": "string",
      "title": "Right",
      "controls": "slider",
      "units": ["px"],
      "min": -100,
      "max": 100,
      "step": 1,
      "default": "0px",
      "responsive": true,
      "group": "Position",
      "hidden": true
    }
  },
  "text_block": {
    "font-family": {
      "type": "string",
      "format": "font",
      "title": "Font Family",
      "hidden": true,
      "group": "Formatting"
    },
    "align": {
      "type": "string",
      "title": "Align",
      "enum": ["left", "center", "right"],
      "responsive": true,
      "group": "Formatting"
    },
    "color": {
      "type": "string",
      "format": "color",
      "title": "Color",
      "group": "Formatting"
    },
    "line-height": {
      "type": "string",
      "title": "Line Height",
      "controls": "slider",
      "units": [],
      "min": 1,
      "max": 3,
      "step": 0.1,
      "default": "1",
      "hidden": true,
      "group": "Formatting"
    }
  },
  "hero_block": {
    "height": {
      "type": "string",
      "title": "Height",
      "units": ["px", "%"],
      "responsive": true,
      "controls": "slider",
      "min": 20,
      "max": 1000,
      "step": 10,
      "default": "200px",
      "group": "Display"
    },
    "shadow": {
      "type": "string",
      "title": "Shadow",
      "format": "shadow",
      "group": "Display",
      "hidden": true
    },
    "border": {
      "type": "border",
      "title": "Border",
      "group": "Display",
      "hidden": true
    },
    "border-radius": {
      "type": "string",
      "title": "Corner radius",
      "units": ["px"],
      "controls": "slider",
      "min": 0,
      "max": 48,
      "step": 1,
      "responsive": true,
      "group": "Display"
    }
  },
  "composed_block": {
    "shadow": {
      "type": "string",
      "title": "Shadow",
      "format": "shadow",
      "group": "Styles"
    },
    "border": {
      "type": "border",
      "title": "Border",
      "group": "Styles"
    },
    "border-radius": {
      "type": "string",
      "title": "Border Radius",
      "units": ["px"],
      "controls": "slider",
      "min": 0,
      "max": 48,
      "step": 1,
      "responsive": true,
      "group": "Styles"
    }
  },
  "button_block": {
    "display": {
      "type": "string",
      "title": "Display",
      "enum": ["block", "inline"],
      "default": "block",
      "group": "Styles",
      "responsive": true
    },
    "border": {
      "type": "border",
      "title": "Border",
      "group": "Styles",
      "hidden": true
    },
    "border-radius": {
      "type": "string",
      "title": "Border Radius",
      "units": ["px"],
      "controls": "slider",
      "min": 0,
      "max": 48,
      "step": 1,
      "group": "Styles",
      "hidden": true,
      "default": "12px"
    },
    "shadow": {
      "type": "string",
      "title": "Shadow",
      "format": "shadow",
      "default": "0 2px 5px 0 #3c42571f",
      "group": "Styles",
      "hidden": true
    },
    "align": {
      "type": "string",
      "title": "Align",
      "enum": ["left", "center", "right"],
      "default": "left",
      "group": "Styles",
      "responsive": true,
      "hidden": true
    }
  }
}
